import config from '../config';
import { loadClient } from '@justgiving/chrome';
import { useCharityData } from '../context/charityContext';
import { useEffect } from 'react';

const loadChromeScript = () => {
  const script = document.createElement('script');
  script.id = 'chrome-script';
  script.src = config.chrome_script_url;
  script.async = true;
  document.body.appendChild(script);
};

export function useChrome() {
  const charityData = useCharityData();

  useEffect(() => {
    if (!charityData?.charity?.operatingCompanyCode) return;
    loadChromeScript();
    window.jgOnRenderChrome = () => {
      window.jg.chrome.refresh();
    };
    loadClient({
      headerVariant: 'charity',
      footerVariant: 'charity',
      countryCode: charityData.charity.operatingCompanyCode,
    });
  }, [charityData?.charity?.operatingCompanyCode]);
}
